import {MediaInterface} from "@/share/types/interface";

export class MilestoneDetailModel {
  id!: number
  name!: string
  type!: number
  categoryType?: number
  order!: number
  milestoneName?: string
  stepCount?: number
  isActive!: boolean
  categoryId!: number
  definition?: string
  howTo?: string
  medias?: MediaInterface[]

  constructor(init: Partial<MilestoneDetailModel>) {
    Object.assign(this, init);
  }
}
